/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type AfterViewInit, type OnInit, Component, ElementRef, ViewChild } from '@angular/core';
import { EventService, LoadingService, PromptService } from '@dm/core';
import RFB from '@novnc/novnc/core/rfb';

import { VirtualMachineService } from '../virtual-machine.service';
import { VirtualMachineServiceStrService } from '../virtual-machine-str.service';

@Component({
    selector: 'app-virtual-machine-console',
    templateUrl: './virtual-machine-console.component.html',
    styleUrls: ['./virtual-machine-console.component.scss'],
})
export class VirtualMachineConsoleComponent implements OnInit, AfterViewInit {
    /**
     * 虚拟机画布
     */
    @ViewChild('virtualMachineConsoleContainer') virtualMachineConsoleContainer: ElementRef;
    /**
     * rfb对象
     */
    rfb: RFB;
    /**
     * 虚拟机url
     */
    vncUrl: string;

    constructor(
        public str: VirtualMachineServiceStrService,
        private service: VirtualMachineService,
        private promptService: PromptService,
        private eventService: EventService,
        private loadingService: LoadingService,
    ) { }

    ngOnInit(): void {
        // 读取 URL 查询参数
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const selectedVirtualMachineName = urlParams.get('selectedVirtualMachine');

        // 比如刷新页面等场景导致获取不到虚拟机名称，不连接，直接提示重新登录
        if (selectedVirtualMachineName === '') {
            this.connectionAbnormaHandel();
            return;
        }

        const conectUrl = this.service.getConectRest(selectedVirtualMachineName);
        this.vncUrl = `wss://${window.location.host}${conectUrl.baseUrl}`;

        this.loadingService.show();
    }

    ngAfterViewInit(): void {
        this.initRfb();
    }

    /**
     * 初始化rfb
     */
    initRfb(): void {
        this.rfb = new RFB(this.virtualMachineConsoleContainer.nativeElement, this.vncUrl);

        // 启动缩放
        this.rfb.scaleViewport = true;

        // 监听connect 事件
        this.rfb.addEventListener('connect', () => {
            this.bindMouseAndKeyEvent();
            this.loadingService.hide();
        });

        // 监听disconnect 事件
        this.rfb.addEventListener('disconnect', () => {
            this.connectionAbnormaHandel();
            this.loadingService.hide();
        });
    }

    /**
     * 关闭浏览器
     */
    closeBrowser(): void {
        window.open('', '_parent', '');
        window.close();
    }

    /**
     * 绑定鼠标键盘事件
     */
    bindMouseAndKeyEvent(): void {
        document.addEventListener('mousedown', ()=>{
            this.eventService.emit('refreshIdleTime');
        });

        document.addEventListener('keydown', ()=>{
            this.eventService.emit('refreshIdleTime');
        });
    }

    /**
     * 连接异常处理
     */
    connectionAbnormaHandel(): void {
        this.promptService.prompt({
            title: this.str.i18n.connectionAbnormalLab,
            content: this.str.i18n.reLoginTip,
            onOk: (): void => this.closeBrowser(),
        });
    }

    /**
     * 发送CTRL+ALT+DELETE
     */
    sendCtrlAltDel(): void {
        this.rfb.sendCtrlAltDel();
    }
}
